;(function ($) {
  $.donationPopup = (function () {
    var selector = '.c-footer-popup.donation_modal'

    return {
      init: function (callback) {
        if ($.isFunction(callback)) callback.call(this)
        return this
      },
      element: function () {
        return $(selector)
      },
      show: function (variant, fallback) {
        var self = this
        var $modal = this.element()
        var deferred = $.Deferred()
        var $donateButton = $modal.find('#donation_modal-donate')

        $modal.prop('class', 'donation_modal c-footer-popup js-c-footer-popup')

        $.ajax({
          type: 'GET',
          url: '/payment_paths/' + variant,
          success: function (response) {
            var path = response.data.id

            $donateButton.attr('href', $donateButton.prop('href') + '?path=' + path)
            $modal.addClass(response.data.type)
            deferred.resolve()
          },
          error: function () {
            $modal.addClass(fallback)
            deferred.resolve()
          },
        })

        $donateButton.on('click', function () {
          self.dismiss(365)
        })

        deferred.then(function () {
          $modal.fadeIn('fast')
        })
      },
      close: function () {
        $(document).trigger('close_modal')
      },
      dismiss: function (numberOfDays) {
        var cookieName = $(document.body).data('donation-modal-cookie-name')

        $.cookie(cookieName, true, {
          expires: numberOfDays,
          path: '/',
        })
      },
    }
  })()
})(jQuery)
